import { _ } from "core-js";

export default {
    computed: {
        totalOnlyUsersLicences() {
            if (null === this.cartBasicProduct.customPricing) {
                const plan = this.getProductPlan(this.pricingBasicProduct, this.currentPricingPlan);
                const quantity = this.cartBasicProduct.quantity - this.cartBasicProduct.quantityFree;
                return quantity * plan.amountInCents / (this.currentPricingPlan === 'YEARLY' ? 12 : 1) / 100;
            }

            return this.cartBasicProduct.customPricing.filter(pricing => pricing.nbLicences !== 0).reduce((acc, value) => acc + (value.nbLicences * value.unit_amount) / (this.currentPricingPlan === 'YEARLY' ? 12 : 1), 0) / 100;
        },
        diffMonthlyYearly() { return this.buildTotal(this.cartItemsIterable, 'MONTHLY').yearly.raw - this.cartTotal.yearly.raw },
    },
    methods: {
        centsToCurrency(cents) { return cents / 100 },
        buildTotal(iterable, pricingPlan) {
            return {
                monthly: {
                    raw: this.totalMonthlyRaw(iterable, pricingPlan, false),
                    discount: this.totalDiscountMonthly(iterable, pricingPlan),
                    totalDiscounted: this.totalDiscountedMonthly(iterable, pricingPlan),
                    tax: this.applyTax(this.totalDiscountedMonthly(iterable, pricingPlan)),
                    totalTaxIncluded: this.totalDiscountedMonthly(iterable, pricingPlan) + this.applyTax(this.totalDiscountedMonthly(iterable, pricingPlan))
                },
                yearly: {
                    raw: this.totalYearlyRaw(iterable, pricingPlan, false),
                    discount: this.totalDiscountYearly(iterable, pricingPlan),
                    totalDiscounted: this.totalDiscountedYearly(iterable, pricingPlan),
                    totalWithCutomPricingYearly: this.totalYearlyRaw(iterable, pricingPlan),
                    tax: this.applyTax(this.totalDiscountedYearly(iterable, pricingPlan)),
                    totalTaxIncluded: this.totalDiscountedYearly(iterable, pricingPlan) + this.applyTax(this.totalDiscountedYearly(iterable, pricingPlan))
                }
            }
        },
        totalMonthlyRaw(iterable, pricingPlan, withCustomPricing) {
            let total = 0;
            withCustomPricing = withCustomPricing == undefined || withCustomPricing;
            iterable.forEach((item) => {
                let subtotal = 0;
                let baseProductAmount;
                let productAmount;

                if (this.pricingBasicProduct === item.product) {
                    baseProductAmount = this.getProductMonthlyAmount(item.product, pricingPlan, false, withCustomPricing && Number.isInteger(parseInt(item.customPricing)) ? item.customPricing : null);
                    productAmount = this.centsToCurrency(pricingPlan === 'MONTHLY' ? baseProductAmount : baseProductAmount / 12);

                    if (!_.isNil(item.customPricing) && item.customPricing.length > 0) {
                        if (withCustomPricing) {
                            subtotal = item.customPricing.filter(pricing => pricing.nbLicences !== 0).reduce((acc, value) => acc + (value.nbLicences * (value.unit_amount === null ? baseProductAmount : value.unit_amount)) / (pricingPlan === 'YEARLY' ? 12 : 1), 0) / 100 ;
                        } else {
                            subtotal = item.customPricing.filter(pricing => pricing.nbLicences !== 0).reduce((acc, value) => acc + (value.nbLicences * productAmount), 0);
                        }
                    } else {
                        subtotal = productAmount * item.quantity - (withCustomPricing && !_.isNil(item.quantityFree) ? item.quantityFree : 0);
                    }
                } else {
                    baseProductAmount = this.getProductMonthlyAmount(item.product, pricingPlan, withCustomPricing, withCustomPricing && Number.isInteger(parseInt(item.customPricing)) ? item.customPricing : null);
                    productAmount = this.centsToCurrency(pricingPlan === 'MONTHLY' ? baseProductAmount : baseProductAmount / 12);
                    subtotal = productAmount;
                }
                total += subtotal;
            });
            return total;
        },
        totalYearlyRaw(iterable, pricingPlan, withCustomPricing) { return this.totalMonthlyRaw(iterable, pricingPlan, withCustomPricing) * 12 },

        totalDiscountMonthly(iterable, pricingPlan) { return this.totalMonthlyRaw(iterable, pricingPlan, false) - this.totalDiscountedMonthly(iterable, pricingPlan) },

        totalDiscountYearly(iterable, pricingPlan) { return this.totalYearlyRaw(iterable, pricingPlan, false) - this.totalDiscountedYearly(iterable, pricingPlan) },

        totalDiscountedMonthly(iterable, pricingPlan) { return this.totalMonthlyRaw(iterable, pricingPlan, true) },

        totalWithCutomPricingYearly(iterable, pricingPlan) { return this.totalYearlyRaw(iterable, pricingPlan)},
        totalDiscountedYearly(iterable, pricingPlan) { 
            if (!this.cartEarlyRenewal) {
                return this.totalYearlyRaw(iterable, pricingPlan)    
            }
            return this.totalYearlyRaw(iterable, pricingPlan) - this.centsToCurrency(this.cartEarlyRenewalDiscount)
        },
        totalComputeDiffs(total, totalToSubstract) {
            return {
                monthly: {
                    raw: total.monthly.raw - totalToSubstract.monthly.raw,
                    discount: total.monthly.discount - totalToSubstract.monthly.discount,
                    totalDiscounted: total.monthly.totalDiscounted - totalToSubstract.monthly.totalDiscounted,
                    tax: total.monthly.tax - totalToSubstract.monthly.tax,
                    totalTaxIncluded: total.monthly.totalTaxIncluded - totalToSubstract.monthly.totalTaxIncluded 
                }, 
                yearly: {
                    raw: total.yearly.raw - totalToSubstract.yearly.raw,
                    discount: total.yearly.discount - totalToSubstract.yearly.discount,
                    totalDiscounted: total.yearly.totalDiscounted - totalToSubstract.yearly.totalDiscounted,
                    tax: total.yearly.tax - totalToSubstract.yearly.tax,
                    totalTaxIncluded: total.yearly.totalTaxIncluded - totalToSubstract.yearly.totalTaxIncluded
                }
            }
        },
        totalProratedAmount(total, end, startOfProration) {
            // define start of proration to "now" if not specified
            if (startOfProration === undefined) startOfProration = new moment();

            // calculates the time prorata coefficient to apply on amount 
            const coeff = (end.diff(startOfProration, 'month', true) / 12).toFixed(2);

            // copy "total" var
            total = {...total};

            // apply coef on only yearly amounts
            total.yearly =  {
                raw: total.yearly.raw * coeff,
                discount: total.yearly.discount * coeff,
                totalDiscounted: total.yearly.totalDiscounted * coeff,
                tax: total.yearly.tax * coeff,
                totalTaxIncluded: total.yearly.totalTaxIncluded * coeff
            }

            return total;
        },
        applyTax(amount) { return this.round(amount * this.currentCountryTaxRate) },
        round(amount, nbDecimals) {
            if (undefined == nbDecimals) nbDecimals = 2;
            const coeff = Math.pow(10, nbDecimals);
            return Math.round((amount + Number.EPSILON) * coeff) / coeff
        },
    },
}
